module.exports = __webpack_public_path__ + "img/icb-leo-elite-e@2x.01da9521.png";